import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppConfig } from '@/hooks/useAppConfig';
import getEventFilterTypes from '@/modules/events/views/EventManager/utils/getEventFilterTypes';
import { EventTypeEnum } from '@/types/schema';

import SingleSelect from '../Select/SingleSelect';
import { FilterValueProps } from '../types';

const KEY_MAP: { [key: string]: string } = {
  [EventTypeEnum.Live]: 'LIVE_EVENT_CONTENT',
  [EventTypeEnum.External]: 'EXTERNAL_EVENT_CONTENT',
  [EventTypeEnum.Offline]: 'OFFLINE_EVENT_CONTENT',
  [EventTypeEnum.RecurringLive]: 'RECURRING_LIVE_EVENT_CONTENT',
  [EventTypeEnum.RecurringExternal]: 'RECURRING_EXTERNAL_EVENT_CONTENT',
  [EventTypeEnum.RecurringOffline]: 'RECURRING_OFFLINE_EVENT_CONTENT',
};

function SessionTypeFilter(props: FilterValueProps) {
  const { t } = useTranslation();
  const appConfig = useAppConfig();
  const { filterValue, onFilterValueChange, disabled, error } = props;

  const options = useMemo(
    () =>
      getEventFilterTypes(t, appConfig, 'all').map((item) => ({
        ...item,
        id: KEY_MAP[item.value as string],
        value: KEY_MAP[item.value as string],
      })),
    [appConfig, t],
  );

  return (
    <SingleSelect
      disabled={disabled}
      error={error}
      filterValue={filterValue}
      options={options}
      onChange={onFilterValueChange}
    />
  );
}

export default SessionTypeFilter;
